// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_jv-0";
export var buttonContainer = "_jv-3";
export var cancelButton = "_jv-4";
export var headerSection = "_jv-6";
export var headerTitle = "_jv-9";
export var messageSideLeft = "_jv-1";
export var messageSideRight = "_jv-2";
export var orderNumberContainer = "_jv-7";
export var orderNumberLabel = "_jv-8";
export var submitButton = "_jv-5";